import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { formDataGenerator } from "../../../../../utils/common";
import { postLinegraph } from "../actions";
import "../style.scss";

const LineGraph = (props) => {
  const {
    postLinegraph,
    LineGraphData,
    urlFund,
    amficode,
    manageApi,
    setManageApi,
  } = props;

  const [yearData, setYearData] = useState();
  // const [loading, setLoading] = useState(false);
  const [mainData, setMainData] = useState();
  const [flag , setFlag] = useState(false);

  useEffect(()=>{
    if(flag == true){
      setFlag(false);
    }
  },[flag]);
console.log("manageApi", manageApi && manageApi)
  const navDates = LineGraphData && LineGraphData.nav_dates && LineGraphData.nav_dates.map((timestamp) => {
    const date = new Date(timestamp * 1000); 
 
    const day = date.getDate().toString().padStart(2, "0"); 
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear(); 
  
    return `${day} ${month} ${year}`;
  })|| [];
 
  const navAmounts = LineGraphData && LineGraphData.nav_amounts && LineGraphData.nav_amounts.map(amount => amount.toFixed(2))|| [];

  const options = {
    chart: {
      // type: "area",
      stacked: false,
      // height: 450,
      // zoom: { type: 'x', enabled: true, autoScaleYaxis: true },
      toolbar: { show: false},
      zoom: { enabled: false },
    },
    dataLabels: { enabled: false },
    markers: { size: 0 },
    xaxis: {
      categories: navDates,
      labels: { show: false },
      axisTicks: { show: false },
      tooltip: {enabled: false},
      // title: { text: "Date",
      //     style: {
      //         fontSize: "14px",
      //         fontWeight: "bold",
      //         color: "#666"
      //     }
      // }
    },
    yaxis: {
      axisBorder: { show: true },
      // title: { text: "NAV Amount",
      //     style: {
      //         fontSize: "14px",
      //         fontWeight: "bold",
      //         color: "#666"
      //     }
      // },
      labels: {
        // formatter: function (value) {
        //   return Math.floor(value); // Remove decimal places
        // },
        formatter: function (value) {
          if (value % 1 === 0) {
            return value.toFixed(0);
          } else {
            return value.toFixed(2);
          }
        },
        // style: {
        //   fontSize: "14px",
        //   // fontWeight: "bold",
        // },
      },
    },
    tooltip: {
      enabled: true,
      custom: function ({ series, seriesIndex, dataPointIndex }) {
        const navAmount = series[seriesIndex][dataPointIndex];
        const timestampNavDates = navDates[dataPointIndex];
 
        return `
        <div style="background: #fff; padding: 8px;">
          <div style="color: rgba(123, 121, 121, 1); font-size: 11px;">NAV</div>
          <div style="color: rgba(35, 31, 32, 1); border-radius: 5px; display: flex; justify-content: space-between; align-items: center;">
            <div style="font-weight: 600; padding-right: 5px; border-right: 2px solid #D3D2D2; font-size: 14px;">${navAmount }</div>
            <div style="font-weight: 600; padding-left: 5px; font-size: 14px;"> ${ timestampNavDates}</div>
          </div>
        </div>
        `;
      },
    },
    title: { 
      text: "Historical NAV", 
      align: "left", 
      style: {
        fontSize: "16px",
        fontWeight: "400",
        color: "#656363",
      },
    },
    stroke: { curve: "smooth", width: 2 },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0.5,
        stops: [0, 100],
      },
    },
    colors: ["#347ABC"], // Line color
  };
  const series = [{ name: "NAV", data: navAmounts }];

  const handleYearClick = (range) => {
    setYearData(range);
    setManageApi(true);
    setFlag(true);
    // setLoading(true);
    // setTimeout(() => {
    //     setLoading(false);
    // }, 1000);
  };

  useEffect(() => {
    if(manageApi && amficode){
      // setLoading(true);
      const payload = {
        timePeriod: yearData ? yearData : "",
        amfiCode: amficode && amficode,
      };
      const typeData = urlFund && urlFund;
      const fetchData = () => {
        postLinegraph(formDataGenerator(payload), typeData);
      };
      setTimeout(() => {
        fetchData();
        setManageApi(false);
        // setLoading(false);
      });
    }
  }, [yearData, amficode, manageApi]);

  useEffect(() => {
    if (LineGraphData && LineGraphData) {
      setMainData(LineGraphData.availablePeriods);
    } 
    if (LineGraphData && LineGraphData.activePeriod) {
      setYearData(LineGraphData.activePeriod);
    } 
  }, [LineGraphData]);

  return (
    // <div className="wrapper">
      <div className="mb-5">
        <div style={{ height: "470px"}}>
          {/* {loading ? (
            <div style={{ height: "450px", fontSize: "18px", fontWeight: "700",  display: "flex", justifyContent: "center", alignItems: "center" }}>
              Graph is loading...
            </div>
          ) : ( */}
            <>
              {(!navAmounts?.length || !navDates?.length) ? (
                <div className="my-3" style={{height: "450px", fontSize: "18px", fontWeight: "700",  display: "flex", justifyContent: "center", alignItems: "center" }}>
                  No data available
                </div>
              ) : (
                <Chart options={options} series={series} type="area" height="450" />
              )} 
            </>
          {/* )} */}
        </div>
        <div className="my-md-3 d-flex justify-content-center flex-wrap">
          {mainData && mainData.map((btn, index) => ( 
              <button 
                key={index}
                className="btn graphbtn"
                onClick={() => handleYearClick(btn.range)}
                style={{
                  backgroundColor: yearData == btn.range ? "#1B4B86" : "",
                  color: yearData == btn.range ? "#fff" : "#1B4B86",
                  border: yearData == btn.range ? "" : "1px solid #1B4B8666",
                }}
              >
                {btn.year}
              </button>
            ))}
        </div>
      </div>
    // </div>
  );
};
const mapStateToProps = (state) => ({
  LineGraphData: state.ProductSolution.home.lineGraphData,
});

const mapDispatchToProps = (dispatch) => ({
  postLinegraph: bindActionCreators(postLinegraph, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LineGraph);
